import React from 'react';

import * as Styled from './popup-menu.style';
import { Colors } from './types';

export type PopupMenuTitleProps = {
  title: string;
  end?: React.ReactNode;
  isSubTitle?: boolean;
  hasBottomBorder?: boolean;
  compact?: boolean;
};

export const PopupMenuTitle: React.FC<PopupMenuTitleProps> = ({
  title,
  end,
  isSubTitle,
  hasBottomBorder,
  compact,
}) => (
  <Styled.TitleContainer
    $color={isSubTitle ? Colors.TextSecondary : undefined}
    $hasBottomBorder={!!hasBottomBorder}
    $compact={!!compact}
    $isSubTitle={!!isSubTitle}
  >
    <Styled.Title $isSubTitle={!!isSubTitle}>{title}</Styled.Title>
    {end}
  </Styled.TitleContainer>
);
